import React from 'react';

const PageCountContext = React.createContext([
    [],
    () => []
])

export default PageCountContext